import {
  CheckCircleFilledIcon,
  InfoCircleFilledIcon,
  WarningFilledIcon,
  CloseCircleFilledIcon,
  StyledAlert,
  BulkImportIcon,
} from './AlertNotification.styled';
import { Flex, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { FanguardApiContractsNotificationIndicatorEnum, NotificationExtended } from 'src/api/generated';
import { useEffect, useState } from 'react';
import { clearNotification } from 'src/stores/notificationsStore';
import ImportProgress from './components/ExtraMessageComponents/ImportProgress/ImportProgress';
import { formatDistanceToNow } from 'date-fns';
import ViewImport from './components/ExtraTimestampComponents/ViewImport/ViewImport';
interface AlertNotificationProps {
  items: NotificationExtended[];
  isAllNotifications?: boolean;
}

export const AlertNotification = (props: AlertNotificationProps) => {
  const { items, isAllNotifications = true } = props;
  const { t } = useTranslation();

  const [displayedNotifications, setDisplayedNotifications] = useState<NotificationExtended[]>(
    isAllNotifications ? items : items.slice(0, 4),
  );

  const getNotificationIcon = (indicator: string) => {
    switch (indicator) {
      case FanguardApiContractsNotificationIndicatorEnum.Success:
        return <CheckCircleFilledIcon />;
      case FanguardApiContractsNotificationIndicatorEnum.Information:
        return <InfoCircleFilledIcon />;
      case FanguardApiContractsNotificationIndicatorEnum.Warning:
        return <WarningFilledIcon />;
      case FanguardApiContractsNotificationIndicatorEnum.Failure:
        return <CloseCircleFilledIcon />;
      case FanguardApiContractsNotificationIndicatorEnum.BulkImport:
        return <BulkImportIcon />;
      default:
        return <WarningFilledIcon />;
    }
  };

  const onClose = (index: number) => {
    setTimeout(() => {
      clearNotification(index);
    }, 500);
  };

  useEffect(() => {
    if (isAllNotifications) {
      return setDisplayedNotifications(items);
    } else {
      setDisplayedNotifications(items.slice(0, 4));
    }
  }, [items, isAllNotifications]);

  const getDescription = (item: NotificationExtended) => {
    // import in progress
    if (item.indicator === FanguardApiContractsNotificationIndicatorEnum.BulkImport) {
      return (
        <>
          <ViewImport item={item} />
          <ImportProgress item={item} />
        </>
      );
    }
    // import successful or failed
    if (item.message === 'Import successful' || item.message === 'Import failed') {
      return (
        <>
          <ViewImport item={item} />
          <ImportProgress item={item} />
        </>
      );
    }
    return (
      <>
        <Typography.Text>{item.message}</Typography.Text>
        <Typography.Text>{formatDistanceToNow(item.timestamp) + ' ' + t('notifications.ago')}</Typography.Text>
      </>
    );
  };

  return displayedNotifications.map((item, index) => (
    <StyledAlert
      indicator={item.indicator}
      closable={true}
      closeIcon={
        <Flex gap={4}>
          {t('general.clear')}
          <CheckCircleOutlined />
        </Flex>
      }
      onClose={() => onClose(index)}
      showIcon={true}
      icon={getNotificationIcon(item.indicator)}
      key={item.id + item.timestamp.toString()}
      message={item.title}
      description={<Flex vertical>{getDescription(item)}</Flex>}
    />
  ));
};
